import React from "react";
import VideoContent from "./components/VideoContent/VideoContent";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import styles from "./VideoPage.module.scss";
import Layout from "@/components/Layout/Layout";

const VideoPageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  return (
    <Layout admin={admin}>
      <div className={styles.blocks}>
        <VideoContent />
      </div>
    </Layout>
  );
};

export const VideoPage = withAdmin(VideoPageCmp);
VideoPageCmp.displayName = "VideoPageCmp";

